import React from 'react'
import classNames from 'classnames/bind'
import { LINK_TO_INFO } from 'constants/links'
import { comparePlansScroller, selectPlanScroller } from 'services/PageScroller'
import { Text as TextType } from 'hocs/localization'
import Heading from 'elements/Heading'
import Text from 'elements/Text'
import Button from 'elements/Button'
import PlanItem from './apps/PlanItem'
import MultiPlanItem from './apps/MultiPlanItem'
import * as styles from './SelectPlan.scss'
import { setScrollElementId } from 'redux-app/modules/pageScroller'

const cx = classNames.bind(styles)

interface IProps {
  t: TextType,
  isUserLogin: boolean,
  subscriptionPlans: any[],
  groupedPlans: any[][],
  setScrollElementId: (name) => void,
  onSelectPlan: () => void,
  onChangeCheckBox: (weight) => void,
  onUpdatePlans: (plans) => void,
}

interface IState {
  plansState: any[],
  groupedPlansState: any[][],
}

class SelectPlan extends React.Component<IProps, IState> {
  public state = {
    plansState: this.props.subscriptionPlans,
    groupedPlansState: this.props.groupedPlans,
  }

  public static getDerivedStateFromProps (props, state) {
    return {
      plansState: props.subscriptionPlans,
    }
  }

  private onChangeCheckBoxState = (weight) => {

    const plansFromState = [...this.state.plansState]
    const plansFromGroup = plansFromState.filter(x => x.weight === weight)

    // exchange plans vivibility
    const firstGroupPlanVisibility = plansFromGroup[0].visible
    plansFromGroup[0].visible = plansFromGroup[1].visible
    plansFromGroup[1].visible = firstGroupPlanVisibility

    this.props.onUpdatePlans(plansFromState)
  }

  private goToComparison = (event) =>
  {
    this.props.setScrollElementId(comparePlansScroller.getElementId());
  }

  public render () {

    const { plansState, groupedPlansState } = this.state
    const {
      t,
      isUserLogin,
      onSelectPlan,
    } = this.props

    return (
      <section id={selectPlanScroller.getElementId()} className={styles.root}>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <header className={styles.header}>
              <Heading title={t('header')} size={2} styleType='sectionHeader' />
              <Text size='xLarge'>
                {t('description')}
              </Text>
              <div className={cx('selectPlanTitle')}>
                <a onClick={event => this.goToComparison(event)}>{t('title')}</a></div>
            </header>
          </div>
          <div className='col-12'>
            <div className={cx('row', 'plans', 'card-group', 'no-gutters')}>

            {Object.keys(groupedPlansState).map((key) => {

              var planItem : any;
              var planItem2 : any;
              
              if (groupedPlansState[key].length > 0) {
                planItem = plansState.find(x => x.id === groupedPlansState[key][0].id);
              }

              if (groupedPlansState[key].length > 1) {
                planItem2 = plansState.find(x => x.id === groupedPlansState[key][1].id);
              }

              return (
                <div
                  key={groupedPlansState[key][0].id}
                  className={cx('col-lg-3', 'col-md-6', 'col-sm-12', 'plan', styles.plan)}
                >
                  {groupedPlansState[key].length === 1 && (
                    <PlanItem
                      key={groupedPlansState[key][0].id}
                      plan={planItem}
                      onSelectSubscriptionPlan={onSelectPlan} t={t} isAccessibleToUser={isUserLogin}
                      isSelectable = {planItem.hasAvailableDevices}
                    />
                  )}
                  {groupedPlansState[key].length > 1 && (
                    <MultiPlanItem
                      plan={planItem}
                      plan2={planItem2}
                      onChangeCheckBox={this.onChangeCheckBoxState}
                      onSelectSubscriptionPlan={onSelectPlan} t={t} isAccessibleToUser={isUserLogin}
                      isSelectable={planItem.hasAvailableDevices}
                      isSelectable2={planItem2.hasAvailableDevices}
                    />
                  )}
                </div>
              )
            },
            )}
            </div>
          </div>
          <div className={styles.actualSavings}>
            <a href={t('links.terms')} className={styles.upperCaseLink} target='_blank'>{t('termsLink')}</a>
            <Text size='xSmall'>
              <div>
                {t('home.actualSavings1')}
                <a href={LINK_TO_INFO} target='_blank'>
                  {t('home.link')}
                </a>
              </div>
              <div>{t('home.actualSavings2')}</div>
            </Text>
          </div>
        </div>
      </div>
    </section>
    )
  }}

export default SelectPlan
